import { authPost } from './authMiddleware';

export const postFolderDelete = (data) => {
    return authPost('/api/portfolio/folder/delete', data);
}